// extracted by mini-css-extract-plugin
export var filterIncDec = "_4k-0";
export var leftBorder = "_4k-1";
export var rightBorder = "_4k-2";
export var stringInput = "_4k-3";